import store from '~/javascripts/store';
import t from '~/javascripts/utils/translation';
import { Component } from 'react';
import { CountryDropdown } from 'react-country-region-selector';
import { observer } from 'mobx-react';

const AddressPopoutForm = observer(
  class AddressPopoutForm extends Component {
    revalidateBillingZipcode = (e) => {
      if (store.donateForm.billingZipcode !== '') {
        setTimeout(() => {
          $(e.target).siblings('#billingZipcode').parsley().validate();
        }, 0);
      }
    };

    render() {
      return (
        <>
          <input
            className='rounded-none rounded-t -mb-px'
            data-parsley-error-message='Please enter your billing address'
            data-parsley-errors-container='.step-payment-errors-list'
            id='billingAddress'
            onChange={(e) => (store.donateForm.billingAddress = e.target.value)}
            placeholder='Billing address'
            required
            type='text'
            value={store.donateForm.billingAddress}
          />

          <input
            className='rounded-none w-1/2 -mr-px'
            data-parsley-error-message='Please enter your city'
            data-parsley-errors-container='.step-payment-errors-list'
            id='billingCity'
            onChange={(e) => (store.donateForm.billingCity = e.target.value)}
            placeholder='City'
            required
            type='text'
            value={store.donateForm.billingCity}
          />

          <input
            className='rounded-none zipcode'
            data-parsley-errors-container='.step-payment-errors-list'
            data-parsley-required-message={t('views.donate_form.zipcode.error')}
            data-parsley-uk-postcode={
              store.donateForm.defaultOrSelectedBillingCountry
            }
            id='billingZipcode'
            onChange={(e) => (store.donateForm.billingZipcode = e.target.value)}
            placeholder={t('views.donate_form.zipcode.placeholder')}
            required
            type='text'
            value={store.donateForm.billingZipcode}
          />

          <CountryDropdown
            classes='rounded-none rounded-b -mt-px mb-2'
            id='billingCountry'
            onChange={(value, e) => {
              store.donateForm.billingCountry = value;
              this.revalidateBillingZipcode(e);
            }}
            required
            showDefaultOption={false}
            value={store.donateForm.defaultOrSelectedBillingCountry}
            valueType='short'
          />

          <div className='step-payment-errors-list' />

          {this.props.children}
        </>
      );
    }
  }
);

export default AddressPopoutForm;
